import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-company-billing',
  templateUrl: './admin-company-billing.component.html',
  styleUrls: ['./admin-company-billing.component.css']
})
export class AdminCompanyBillingComponent implements OnInit {

  
  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }
  companies = [];
  billings = [];
  authToken = localStorage.getItem('auth');
  finalSum = 0;
  routeID = this.route.snapshot.params.id;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };


  ngOnInit(): void {
    this.fetchBilling();
  }

  fetchBilling() {
    //Epoch time

    //Get first day of the month at 00:00:00
    var date = new Date();
    var epoch = date.getTime();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0);
    var firstDayEpoch = firstDay.getTime();

    //Get current state of the month
    var date = new Date();
    var epoch = date.getTime();

    var end_path = '?start=' + firstDayEpoch + '&end=' + epoch;

    (<HTMLInputElement>document.getElementById("start")).value = firstDay.toISOString().substring(0, 10);
    (<HTMLInputElement>document.getElementById("end")).value = date.toISOString().substring(0, 10);


    this.http.get(environment.ADMIN_COMPANY_BILLING+ '/' + this.routeID + end_path, this.httpOptions).subscribe(
      (res: any) => {
        console.log(res);
        if(res.status == 200 ) {
          this.billings = res.message;

          for (let i = 0; i < this.billings.length; i++) {
            const bill = this.billings[i];
            bill.name = this.formateName(bill.type);

            this.finalSum += bill.price;
          }

         
        }
        else {
          console.log('buu')
          this.billings = [];
        }
        
      }, (err: any) => {

      }
    )
  

}

formateName(name) {
  if(name){
    switch(name){
      case 'marketplace_leave':
        return 'Marketplace ilmoitus';
      case 'marketplace_bid':
        return 'Marketplace tarjous';
      case 'wishlist_profile_opening':
        return 'Toiveen avaus';
      case 'feed_ads':
        return 'Mainos';
      case 'application_profile_opening':
        return 'Hakemuksen avaus';
      case 'headhunting_profile_opening':
        return 'Headhunting avaus';
      case 'company_pinning':
        return 'Logo mobiiliappin etusivulle';
      default:
        return name;

    }
  }
}



}
